
import EventBus from '../event-bus'

export const formMixin = {
  methods: {
    /**
     * Clean form errors
    */
    cleanForm(){
      for (const key in this.form.inputs) {
        this.form.inputs[key].invalidFeedback = ''
        this.form.inputs[key].state   = null
        this.form.model[key] = ''
      }
    },
    /**
     * Submit the form to server
     */
    submit(){
      this.isLoading    = true
      const self        = this
      const model =  self.form.model
      this.$http[self.form.config.httpMethod](self.form.config.apiUri, model)
        .then(response => {
          self.isLoading = false
          EventBus.$emit('show-alert', {
            type: 'success',
            title: 'Sucesso !',
            description: response.data.message,
          })
          self.cleanForm()
        }).catch(response =>{
        self.displayErros(response.body)
        self.isLoading = false
      })
    },
    /**
     * Display validation errors
     */
    displayErros (errors) {
      for (const key in this.form.inputs) {
        if (errors[key]) {
          this.form.inputs[key].invalidFeedback = errors[key].toString()
          this.form.inputs[key].state   = false
        } else {
          this.form.inputs[key].invalidFeedback = ''
          this.form.inputs[key].state   = true
        }
      }
    },
  }
}
